import {
  GET_SITE_INFOS_IN_PROGRESS,
  GET_SITE_INFOS_SUCCESS,
  GET_SITE_INFOS_FAIL,
  POST_SITE_IN_PROGRESS,
  POST_SITE_SUCCESS,
  POST_SITE_FAIL,
  PUT_SITE_IN_PROGRESS,
  PUT_SITE_SUCCESS,
  PUT_SITE_FAIL,
} from "../constants";

const initialState = {
  infos: undefined,
  saving: false,
  saved: false,
  errors: null,
};

/**
 * Site reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function site(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_SITE_INFOS_IN_PROGRESS:
      return {
        ...state,
        infos: undefined,
      };

    case GET_SITE_INFOS_SUCCESS:
      return {
        ...state,
        infos: payload.infos,
      };

    case GET_SITE_INFOS_FAIL:
      return {
        ...state,
        infos: null,
      };

    case POST_SITE_IN_PROGRESS:
    case PUT_SITE_IN_PROGRESS:
      return {
        ...state,
        saving: true,
        saved: false,
        errors: null,
      };

    case POST_SITE_SUCCESS:
    case PUT_SITE_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
      };

    case POST_SITE_FAIL:
    case PUT_SITE_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        errors: payload.violations,
      };

    default:
      return state;
  }
}
